<div class="ui segment wrapper">
    <div class="header-wrapper">
        <mat-icon [svgIcon]="timeOffType.icon" [ngStyle]="{ color: timeOffType.color }"></mat-icon>
        <h2 class="ui header">{{ timeOffType.name }}</h2>
        <ui-badge type="default" *ngIf="timeOffType.isDefault">{{ 'time-off-v3.default' | translate }}</ui-badge>
    </div>
    <div class="progress-info-wrapper">
        <div>{{ 'time-off-v3.currentlyUpdatingPolicyData' | translate }}</div>
        <div>{{ progress | i18nNum: '%' }}</div>
    </div>
    <div class="progress-bar-wrapper">
        <mat-progress-bar mode="determinate" [value]="progress"></mat-progress-bar>
    </div>
</div>
